<template>
  <div class="analytic-tab-pane tab-pane">
    <div class="tab-pane-header">
      <div class="tab-pane-header__title"> {{ chartType }}</div>
      <div class="tab-pane-header__filter">
        <el-date-picker
            @change="handleDatePickerChange"
            v-model="dateRange"
            :picker-options="datePickerOptions"
            type="daterange"
            class="date-range-picker"
            format="MM-dd-yyyy" :clearable="false"
            value-format="yyyy-MM-dd"
            size="mini" align="right"
            start-placeholder="Start Date"
            end-placeholder="End Date">
        </el-date-picker>
        <el-button-group>
          <el-button size="mini" v-for="item in suitableFilters"
              @click="handleDateRangeFilterChange(item.filter)"
              :class="{'active-filter-btn': dateRangeFilter === item.filter }"
          >
            {{ item.title }}
          </el-button>
        </el-button-group>
      </div>
    </div>
    <div class="tab-pane-body">
      <div class="charts-row" v-for="row in chunked(charts[chartType], 2)">
        <CustomersChartBlock
            v-for="block in row"
            :info="block"
            :period="dateRange"
            :chart-data="chartDataGetter[block.key]"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import analyticFormatData from '@/mixins/analyticFormatData'
  import CustomersChartBlock from './CustomersChartBlock'

  export default {
    name: 'CustomersChartsTabPane',
    props: {
      chartType: {
        type: String,
        required: true,
        validator: type => ['Customers', 'Plan', 'Reports'].includes(type)
      }
    },
    mixins: [analyticFormatData],
    components: {
      CustomersChartBlock
    },
    data() {
      return {
        charts: {
          Customers: [
            { title: 'Register today', type: 'bar', key: 'registar_today' },
            { title: 'Active today', type: 'bar', key: 'active_today' },
            { title: 'Users', type: 'pie', key: 'users' },
            { title: 'Marital status', type: 'pie', key: 'marital_status' },
            { title: 'Age range', type: 'pie', key: 'age' },
            { title: 'Gender', type: 'pie', key: 'gender' }
          ],
          Plan: [
            { title: 'All', type: 'pie', key: 'overall' },
            { title: 'Flex', type: 'pie', key: 'dating_and_social' },
            { title: 'XXX', type: 'pie', key: 'xxx_and_cams' }
          ],
          Reports: [
            { title: 'All', type: 'pie', key: 'overall' },
            { title: 'Flex', type: 'pie', key: 'flex' },
            { title: 'XXX', type: 'pie', key: 'xxx' },
            { title: 'Listing Locator', type: 'pie', key: 'listing_locator' },
            { title: 'Tinder', type: 'pie', key: 'tinder' }
          ]
        },
        dateRange: [],
        dateRangeFilter: 'currentMonth',
        suitableFilters: [
          { filter: 'today', title: 'Day' },
          { filter: 'currentWeek', title: 'Week' },
          { filter: 'currentMonth', title: 'Month' },
          { filter: 'currentYear', title: 'Year' }
        ],
        datePickerOptions: {
          firstDayOfWeek: 1,
          disabledDate: this.handleMinMaxDatePicker
        }
      }
    },
    computed: {
      chartDataGetter() {
        return this.$store.getters[`analytic/get${this.chartType}`]
      }
    },
    methods: {
      handleDateRangeFilterChange(filter) {
        this.dateRangeFilter = filter
        this.dateRange = filter === 'today' ? [this.date().today, this.date().today] : [this.date()[filter], this.date().today]

        this.$store.dispatch(`analytic/get${this.chartType}Chart`, this.dateRange)
      },
      handleDatePickerChange(range) {
        this.dateRange = range
        this.$store.dispatch(`analytic/get${this.chartType}Chart`, this.dateRange)
      }
    },
    created() {
      this.dateRange = [this.date()[this.dateRangeFilter], this.date().today]
      this.$store.dispatch(`analytic/get${this.chartType}Chart`, this.dateRange)
    }
  }
</script>

<style lang="scss" scoped>
  $breakpoint-md: 992px;

  .tab-pane {
    @media (max-width: 1024px) {
      margin-bottom: 200px;
    }

    &-header {
      display: flex;
      flex-direction: column;
      margin: 10px 0;
      padding-bottom: 10px;
      border-bottom: 1px solid #E4E7ED;

      &__title {
        font-size: 28px;
        font-weight: 600;
        padding-bottom: 10px;
      }

      &__filter {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-bottom: 10px;

        @media (max-width: 992px) {
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        .date-range-picker {
          @media (max-width: 550px) {
            width: 75%;
            margin-bottom: 5px;
          }
          @media (min-width: 550px) {
            width: 55%;
          }
          @media (min-width: 768px) {
            width: 55%;
          }
          @media (min-width: 992px) {
            width: 35%;
          }
          @media (min-width: 1100px) {
            width: 40%;
          }
          @media (min-width: 1200px) {
            width: 25%;
          }
        }

        .active-filter-btn {
          font-weight: 600;
          color: #3366cd;
        }
      }
    }

    &-body {
      .charts-row {
        display: flex;
        flex-direction: row;

        @media (max-width: 1024px) {
          flex-direction: column;
        }

        &:last-child {
          justify-content: center;
        }
      }
    }
  }
</style>
